export default [
  ...Array.from({ length: 14 }, () => 0),
  ...Array.from({ length: 12 }, () => 1),
  ...Array.from({ length: 12 }, () => 2),
  ...Array.from({ length: 12 }, () => 3),
  ...Array.from({ length: 12 }, () => 4),
  ...Array.from({ length: 12 }, () => 5),
  ...Array.from({ length: 12 }, () => 6),
  ...Array.from({ length: 12 }, () => 7),
  ...Array.from({ length: 12 }, () => 8)
];
